// extracted by mini-css-extract-plugin
export default {"brandPromo":"VG-z","carousel":"WG-z"};